<script lang="ts" setup>
import { inject, ref } from "vue"
import type { Services, ServiceResponse } from "@types"

const { $searchAddress } = inject<Services>("services") || {}

interface Props {
    id: string
    placeholder: string
    invalid?: boolean
    label?: string
    error?: string
    disabled?: boolean
}

withDefaults(defineProps<Props>(), {
    id: "input-address",
    label: "",
    error: "",
    disabled: false,
})

const [modelValue] = defineModel<object | string | null>({
    set(value) {
        if (typeof value === "string") {
            return value
        } else {
            return value
        }
    },
})

const innerAddress = ref<string | object>("")

const suggestions = ref<ServiceResponse["GetAddressResponse"]>([])

async function onSearch($event: { query: string }) {
    // fetch data from API
    try {
        const result = await $searchAddress!($event.query)
        suggestions.value = result
    } catch {
        // nothing
    }
}

function onUpdateModelValue(value: string | object) {
    if (typeof value !== "string") {
        modelValue.value = value
    } else {
        modelValue.value = null
    }
    innerAddress.value = value
}
</script>

<template>
    <BaseInputWrapper
        class="input-address"
        :label="label"
        input-id="address"
        :error="error"
    >
        <BaseAutoComplete
            :value="innerAddress"
            @update:modelValue="onUpdateModelValue"
            option-label="inline_name"
            :invalid="invalid"
            :id="id"
            :placeholder="placeholder"
            :suggestions="suggestions"
            :disabled="disabled"
            fluid
            @complete="onSearch"
        >
        </BaseAutoComplete>
    </BaseInputWrapper>
</template>
